<template>
  <b-container class='d-flex h-100 w-100 overflow-auto px-0 position-absolute'>
    <div class="w-100 h-100">
      <!--  Notification-->
      <notification :options.sync="options" :show.sync="showNotification" @close="closeNotification"></notification>

      <!--  Modals  -->
      <checkbox-modal
        :model="dob"
        :schema="dobField"
        :modalBody.sync="dobBody"
        formName="dateForm"
        hasInput="false"
        hasClose="false"
        :show.sync="ageVerification"
        @checkValues="checkDOB">
          <div slot="action">
            <br />
            <button type="button" class="spnod-form__button spnod-button--primary" :disabled="isDisabled" v-on:click.stop.prevent="setDOB()">OK</button>
          </div>
      </checkbox-modal>
      <checkbox-modal
        :model="terms"
        :schema="clientTermsSchema"
        :modalBody.sync="clientTermsBody"
        formName="clientTermsForm"
        hasInput="false"
        hasClose="false"
        :show="(actionRequired === 'agreeTerms' || actionRequired === 'confirmMedical') && getMyInfo._id === activeClient"
        @checkValues="checkTerms">
          <div slot="header">
            <h3>Terms &amp; Conditions</h3>
          </div>
          <div slot="action">
            <br />
            <button
              type="button"
              class="spnod-form__button spnod-button--primary"
              :disabled="termsProvided === false"
              v-on:click.stop.prevent="setTerms()">
                OK
            </button>
          </div>
      </checkbox-modal>
      <checkbox-modal
        :model="{}"
        :schema="[]"
        :modalBody.sync="additionalEmailsBody"
        formName="additionalEmailsForm"
        hasInput="false"
        hasClose="false"
        :show="actionRequired === 'requireAdditionalUser'">
          <div slot="action">
            <br />
            <router-link
              class="spnod-form__button spnod-button--primary"
              :to="{ name: 'addParent', params: {fromRoute: this.$route.name, signupData: getMyInfo}}">
              OK
            </router-link>
          </div>
      </checkbox-modal>
      <checkbox-modal
        :model="terms"
        :schema="parentTermsSchema"
        :modalBody.sync="parentTermsBody"
        formName="parentTermsForm"
        hasInput="false"
        hasClose="false"
        :show="actionRequired === 'agreeTerms' && getMyInfo._id !== activeClient"
        @checkValues="checkTerms">
          <div slot="header">
            <h3>Terms &amp; Conditions</h3>
          </div>
          <div slot="action">
            <br />
            <button
              type="button"
              class="spnod-form__button spnod-button--primary"
              :disabled="termsProvided === false"
              v-on:click.stop.prevent="setTerms()">
              OK
            </button>
          </div>
      </checkbox-modal>
      <checkbox-modal
        :model="myConsent"
        :schema="provideConsentSchema"
        :modalBody.sync="provideConsentBody"
        hasInput="false"
        hasClose="false"
        :show="actionRequired === 'provideConsent' && getMyInfo._id !== activeClient && !getMyInfo.hasRoles"
        @checkValues="checkIfConsented">
          <div slot="header">
            <h3>Please provide consent for {{clientName}}</h3>
          </div>
          <div slot="action">
            <br />
            <button
              type="button"
              class="spnod-form__button spnod-button--primary"
              :disabled="consentProvided === false"
              v-on:click.stop.prevent="setConsent()">
              OK
            </button>
          </div>
      </checkbox-modal>

      <div class="spnod-messages w-100 h-100 d-flex flex-column p-2">
        <!--  Consent  -->
        <div v-if="consentMessage !== null" class="d-flex flex-column h-100 w-100">
          <div v-html="consentMessage"></div>
          <div class="flex-grow-1"></div>
          <router-link v-if="showSubscribe" to="/payment" class="mx-auto">
            <b-button class="spnod-admin__form--button mb-2" size="sm">Subscribe</b-button>
          </router-link>
          <router-link v-if="showParentSubscribe" to="/user" class="mx-auto">
            <b-button class="spnod-admin__form--button mb-2" size="sm">Manage Users</b-button>
          </router-link>
        </div>

        <!--  Loading Animation  -->
        <div v-if="!showMessages && loading" class="d-flex flex-column h-100 w-100">
          <div class="loader mx-auto"></div>
          <div class="flex-grow-1 overflow-auto spnod-messages-container">
            <MessageBody
              v-for="(message, index) in getMessages"
              :key="index"
              :message="message"
              :index="index"/>
          </div>
          <router-link v-if="!displayTextarea() && showParentSubscribe" to="/user" class="mx-auto">
            <b-button class="spnod-admin__form--button mb-2" size="sm">Manage Users</b-button>
          </router-link>
        </div>

        <div v-if="showMessages" class="d-flex flex-column h-100 w-100">
          <!--  Loading Animation  -->
          <div v-if="loading" class="d-flex flex-column h-100 w-100">
            <div class="loader mx-auto mb-5"></div>
            <div class="flex-grow-1"></div>
          </div>

          <!--  Messages  -->
          <div class="flex-grow-1 overflow-auto spnod-messages-container">
            <MessageBody
              v-for="(message, index) in uniqueMessages"
              :key="index"
              :message="message"
              :index="index"
              v-on:initScrollListener="initScrollListener"/>
          </div>

          <div
            class="pt-3"
            v-if="actionRequired === 'parentAwaitingClient'">
            <p class="text-center text-primary">
              Awaiting all message participants to complete account activation before messaging can begin
            </p>
          </div>

          <!--  Textarea  -->
          <TextArea
            v-if="displayTextarea() && actionRequired !== 'parentAwaitingClient'"
            id="textarea"
            class="pt-3"
            :model="model"
            :consented="consented"
            v-on:sendMessage="sendMessage"
            v-on:scrollPage="scrollPage"/>

          <router-link v-if="showSubscribe" to="/payment" class="mx-auto">
            <b-button class="spnod-admin__form--button mb-2" size="sm">Subscribe</b-button>
          </router-link>
          <router-link v-if="!displayTextarea() && showParentSubscribe" to="/user" class="mx-auto">
            <b-button class="spnod-admin__form--button mb-2" size="sm">Manage Users</b-button>
          </router-link>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import CheckboxModal from '../CheckboxModal/CheckboxModal'
import * as moment from 'moment'
import formFields from '../../../assets/formSchemas/formFields.json'
import Notification from '../Notifications/Notification'
import MessageBody from './MessageBody'
import TextArea from './TextArea'

/* TODO
  - highlight inactive participants in red
  - bounce logged in user if they are inactive on this thread
*/
export default {
  name: 'MessageThread',
  props: ['messageId', 'threadId'],
  data() {
    return {
      actionRequired: null,
      activeClient: null,
      animatingLoader: false,
      clientName: null,
      ageVerification: false,
      consented: true,
      consentMessage: null,
      dob: {},
      dobField: formFields.dob,
      dobBody: 'ageVerification',
      isDisabled: true,
      loading: true,
      model: {},
      toolTipStyle: {
        left: '0px',
        top: '0px'
      },
      listenerTimeout: null,
      showNotification: false,
      defaultNotificationMessage: 'New message arrived, scroll down to view',
      options: {
        autoClose: true,
        countdownBar: true,
        content: 'New message arrived, scroll down to view',
        showTime: 3000
      },
      numMessages: 0,
      connectionAttempt: 0,
      messagesLoaded: false,
      terms: {},
      termsProvided: false,
      clientTermsBody: 'terms.client',
      clientTermsSchema: formFields.clientTermsSchema,
      additionalEmailsBody: 'additionalusers',
      parentTermsBody: 'terms.parent',
      parentTermsSchema: formFields.parentTermsSchema,
      provideConsentSchema: formFields.provideConsentSchema,
      provideConsentBody: 'provideconsent',
      myConsent: {},
      consentProvided: false,
      scrollHeight: 0,
      watchScroll: false
    }
  },
  computed: {
    title() {
      return 'Message Thread'
    },
    ...mapGetters([
      'getMessageThread',
      'getMyInfo',
      'hasUnread',
      'getMessageParticipants',
      'canSend',
      'getParticipantConsent',
      'getActiveSubscription',
      'getActiveUserSubscription',
      'getMessages'
    ]),
    message() {
      return this.getMessages.find(m => m.threadId === this.$route.query.threadId)
    },
    uniqueMessages() {
      return this.getMessageThread.reduce((msgs, current) => {
        const msg = msgs.find(item => item._id === current._id)
        if (!msg) {
          return msgs.concat([current])
        } else {
          return msgs
        }
      }, [])
    },
    participants() {
      if (this.message) return this.message.participants
    },
    showMessages() {
      const isNutritionist = this.getMyInfo && this.getMyInfo.hasRoles
      const isParticipant = this.participants && this.participants.some(p => p._id === this.getMyInfo._id)
      return isNutritionist || isParticipant
    },
    showSubscribe() {
      if (!this.message) return false
      return !this.message.client || (!this.getMyInfo.hasRoles && this.message.client._id === this.getMyInfo._id && !this.getActiveSubscription)
    },
    showParentSubscribe() {
      if (!this.message || !this.message.client) return false
      return (!this.getMyInfo.hasRoles && this.message.client._id !== this.getMyInfo._id && !this.getActiveSubscription)
    }
  },
  methods: {
    ...mapActions([
      'listenForMessages',
      'loadMessageThread',
      'doSendMessage',
      'addNewMessage',
      'getMe',
      'updateUnread',
      'doReadMessage',
      'getParticipantInfo',
      'isConnected',
      'doProfileUpdate',
      'participantConsent',
      'updateConsent',
      'loadActiveUserSubscriptions'
    ]),
    async markAsRead(message) {
      if (this.getMyInfo && message.sender && (message.sender._id !== this.getMyInfo._id)) {
        const packet = {
          agentData: {_id: this.$route.query.threadId},
          data: message
        }
        this.$store.commit('UPDATE_THREAD', packet.agentData._id)
        return this.doReadMessage(packet)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    checkValidity (formName) {
      let form = this.$el.querySelector('#' + formName)
      if (form !== null) {
        this.isDisabled = !form.checkValidity()
      }
    },
    checkDOB() {
      this.checkValidity('dateForm')
    },
    async setDOB() {
      await this.doProfileUpdate(this.dob)
      this.ageVerification = false
      if (this.$route.query.messageId) await this.participantConsent(this.$route.query.messageId)
      await this.checkConsent()
    },
    checkIfConsented() {
      this.consentProvided = false
      if (this.myConsent.provideConsent === true) {
        this.consentProvided = true
      }
    },
    async setConsent() {
      if (this.myConsent.provideConsent === true) {
        await this.updateConsent({ client: this.activeClient, accepted: true })
        this.actionRequired = null
        if (this.$route.query.messageId) await this.participantConsent(this.$route.query.messageId)
        await this.checkConsent()
      }
    },
    checkTerms() {
      this.termsProvided = false
      if (this.terms.agreeTerms === true) {
        if (this.getMyInfo._id === this.activeClient) {
          if (this.terms.confirmNoMedicalCondition === true) {
            this.termsProvided = true
          }
        } else {
          this.termsProvided = true
        }
      }
    },
    async setTerms() {
      if (this.terms.agreeTerms === true) {
        this.terms.agreeTerms = new Date()
        await this.doProfileUpdate(this.terms)
        this.actionRequired = null
        if (this.$route.query.messageId) await this.participantConsent(this.$route.query.messageId)
        await this.checkConsent()
      }
    },
    getParticipantName(reader) {
      const currentParent = this.getMessageParticipants.find(o => o._id === reader.readBy)
      if (!currentParent) return
      const readDate = this.getReadByDate(reader)
      if (currentParent.inActive && this.getMyInfo.hasRoles === false) {
        return '<span></span>'
      } else if (currentParent.inActive && this.getMyInfo.hasRoles === true) {
        return '<span class="spnod-message__participant--inactive">' + currentParent.name + ' - ' + readDate + '</span>'
      } else {
        return '<span>' + currentParent.name + ' - ' + readDate + '</span>'
      }
    },
    getReadByDate(reader) {
      return moment(reader.readDate).format('lll')
    },
    getClientName() {
      let activeClient = this.activeClient
      return this.getMessageParticipants.filter(ppt => {
        return ppt._id === activeClient
      })
    },
    getAvatar(message) {
      const participants = this.getMessageParticipants
      let profilePic = null
      for (let i = 0; i < participants.length; i++) {
        if (!message.sender) break
        if (message.sender._id === participants[i]._id) {
          profilePic = participants[i].profilePic
          break
        }
      }
      return profilePic
    },
    async loadAvatars(message) {
      const participants = this.getMessageParticipants
      let participantFound = false
      for (let i = 0; i < participants.length; i++) {
        if (!message.sender) break
        if (message.sender._id === participants[i]._id) {
          participantFound = true
        }
      }
      if (!participantFound) {
        return this.getParticipantInfo(message.sender)
      }
    },
    async sendMessage() {
      const firstMessage = this.getMessageThread[0]
      const newMessage = {
        sender: { _id: this.getMyInfo._id },
        participants: firstMessage.participants,
        client: { _id: firstMessage.client._id },
        nutritionist: firstMessage.nutritionist,
        messageBody: this.model.messageBody
      }
      try {
        const packet = {
          agentData: { _id: this.$route.query.threadId },
          data: newMessage
        }
        this.listenForMessages(packet.agentData._id)
        this.doSendMessage(packet)
        this.model.messageBody = ''
      } catch (err) {
        console.log(err)
      }
    },
    doSubscribe() {
      this.$router.push('/order')
    },
    scrollPage() {
      // Take to latest message
      let messageContainer = document.querySelector('body')
      window.scrollTo(0, messageContainer.scrollHeight)
    },
    async checkConsent() {
      let i = 0
      let j = 0
      let consentLength = (Array.isArray(this.getParticipantConsent.results) === true ? this.getParticipantConsent.results.length : 0)
      let consentMessages = []
      let consentMessagesLength = 0

      this.consentMessage = null
      this.consented = true
      if (Array.isArray(this.getParticipantConsent.results) !== true) {
        this.consented = false
        this.consentMessage = '<p>You do not have an active subscription</p>'
        return
      }
      if (this.getParticipantConsent.results && this.getParticipantConsent.results.length) {
        this.activeClient = this.getParticipantConsent.results[0].client
      }
      for (i = 0; i < consentLength; i++) {
        consentMessages = this.getParticipantConsent.results[i].messages || []
        consentMessagesLength = consentMessages.length
        if (this.getParticipantConsent.results[i].role === 'Client') {
          let clientArray = this.getClientName()
          if (Array.isArray(clientArray) === true && clientArray.length > 0) {
            this.clientName = this.getClientName()[0].name
          }
        }
        if (consentMessages.length > 0) {
          if (consentMessages[0].actionRequired === 'accessRestricted') {
            this.consented = false
            this.consentMessage = '<h3>Access restircted:</h3><br /><ul>'
            for (j = 0; j < consentMessagesLength; j++) {
              this.consentMessage = this.consentMessage + '<li>' + consentMessages[j].message + '</li>'
            }
            this.consentMessage = this.consentMessage + '</ul>'
            break
          }
          if (this.getParticipantConsent.results[i].role === 'Client' && this.getMyInfo._id !== this.activeClient && (consentMessages[0].actionRequired === 'agreeTerms' || consentMessages[0].actionRequired === 'confirmMedical')) {
            this.actionRequired = 'parentAwaitingClient'
          }
          if (this.getParticipantConsent.results[i].role === 'Client' && this.getMyInfo._id === this.activeClient) {
            this.consented = false
            this.actionRequired = consentMessages[0].actionRequired
            break
          }
          if (this.getParticipantConsent.results[i].role !== 'Client' && this.getParticipantConsent.results[i].role === 'Parent' && this.getMyInfo._id !== this.activeClient && !this.getMyInfo.hasRoles) {
            if (this.getParticipantConsent.results[i]._id === this.getMyInfo._id) {
              this.consented = false
              this.actionRequired = consentMessages[0].actionRequired
              break
            }
          }
          if (this.getParticipantConsent.results[i].role !== 'Client' && (this.getMyInfo._id.toString() === this.activeClient || this.getMyInfo.hasRoles || this.getParticipantConsent.results[i].role === 'Parent')) {
            this.consented = false
            this.consentMessage = '<h3>The following items need to be addressed before communication is enabled:</h3><br /><ul>'
            for (j = 0; j < consentMessagesLength; j++) {
              this.consentMessage = this.consentMessage + '<li>' + consentMessages[j].message + '</li>'
            }
            this.actionRequired = consentMessages[0].actionRequired
            this.consentMessage = this.consentMessage + '</ul>'
            break
          }
        }
      }
      if (this.consented === true) {
        await this.setupMessageListeners()
        this.watchScroll = true
        let msgs = this.$el.querySelector('.spnod-messages-container')
        if (msgs === undefined || msgs === 'undefined' || msgs === null || msgs.style.display === 'none') {
          console.log('consented scroll to pos')
          this.scrollToPosition()
        } else {
          msgs.scrollTop = msgs.scrollHeight
        }
      }
    },
    async setupMessageListeners() {
      const response = await this.loadMessageThread({messageId: this.$route.query.messageId, skip: this.$store.state.messaging.skip})
      const results = response.results
      if (results && results[0] && results[0].client) {
        this.activeClient = results[0].client._id
        this.loadAvatars(results[0])
        results.forEach(message => {
          if (message.sender._id !== this.getMyInfo._id && message.readers.filter(r => r.readBy === this.getMyInfo._id).length === 0) {
            this.markAsRead(message)
          }
        })
        this.updateUnread(false)
      }
      this.listenForMessages(this.$route.query.threadId)
      this.messagesLoaded = true
      this.loading = false
      const messageContainer = this.$el.querySelector('.spnod-messages-container')
      if (messageContainer !== null) {
        const messagesScrollTop = (messageContainer.scrollHeight - this.scrollHeight >= 50 ? messageContainer.scrollHeight - this.scrollHeight - 50 : messageContainer.scrollHeight - this.scrollHeight)
        messageContainer.scrollTop = messagesScrollTop
        const loader = this.$el.querySelector('.loader')
        if (loader !== null) {
          messageContainer.scrollTop = messageContainer.scrollTop - loader.offsetHeight
        }
        setTimeout(() => {
          if (messageContainer.scrollTop < 100) {
            messageContainer.scrollTop = 0
          }
        }, 200)
        setTimeout(() => {
          this.animatingLoader = false
        }, 500)
      }
    },
    closeNotification() {
      this.showNotification = false
      this.options['content'] = this.defaultNotificationMessage
      this.options['autoClose'] = true
    },
    scrollToPosition() {
      setTimeout(function() {
        let msgs = this.$el.querySelector('.spnod-messages-container')
        if (msgs === undefined || msgs === 'undefined' || msgs === null || msgs.style.display === 'none') {
          this.scrollToPosition()
        } else {
          msgs.scrollTop = msgs.scrollHeight
        }
      }.bind(this), 200)
    },
    onScroll() {
      const container = this.$el.querySelector('.spnod-messages-container')
      if (container.scrollTop === 0 && this.animatingLoader === false && this.watchScroll) {
        this.animatingLoader = true
        this.loading = true
        this.scrollHeight = container.scrollHeight
        this.setupMessageListeners()
      }
    },
    async loadThread() {
      this.loading = true
      this.watchScroll = false
      this.actionRequired = null
      this.$store.commit('RESETTHREAD')
      await this.$store.dispatch('setActiveThread', this.$route.query.threadId)
      await this.getMe()
      const activeParticipant = this.getMessageParticipants.find(o => o.email === this.getMyInfo.email)
      if (activeParticipant && activeParticipant.inActive === true) { // todo: this may also include pendingInactive
        this.consentMessage = '<p>You are not currently an active participant in this conversation.</p>'
        this.consented = false
      }

      if (this.getMyInfo.isClient === true && !this.getMyInfo.DOB) {
        if (this.getMyInfo.biometrics && this.getMyInfo.biometrics.DOB) {
          await this.doProfileUpdate({ DOB: this.getMyInfo.biometrics.DOB })
        } else {
          this.ageVerification = true
        }
      }
      if (this.ageVerification !== true) {
        if (this.getMyInfo.agreeTerms && this.getMyInfo.agreeTerms !== false) {
          this.terms['agreeTerms'] = true
        }
        if (this.getMyInfo.confirmNoMedicalCondition) {
          this.terms['confirmNoMedicalCondition'] = this.getMyInfo.confirmNoMedicalCondition
        }
        if (this.$route.query.threadId) {
          await this.participantConsent(this.$route.query.messageId)
          await this.checkConsent()
        }
      }
      this.loading = false
    },
    initScrollListener() {
      const thread = this.$el.querySelector('.spnod-messages-container')
      if (thread) thread.addEventListener('scroll', this.onScroll, false)
    },
    displayTextarea() {
      if (!this.getMessageThread.length) return false
      const message = this.getMessages.find(m => m.threadId === this.$route.query.threadId)
      if (!message || !message.client || !message.client.nutritionist) return false
      const isActiveNutritionist = message.client.nutritionist._id === this.getMyInfo._id && !!this.getActiveUserSubscription
      const clientActive = (message.client._id === this.getMyInfo._id) ? !!this.getActiveSubscription : !!this.getActiveUserSubscription
      return this.getMyInfo.hasRoles ? isActiveNutritionist : clientActive
    }
  },
  beforeDestroy() {
    this.$store.commit('RESETTHREAD')
    clearInterval(this.listenerTimeout)
  },
  mounted: async function () {
    if (this.$route.query.messageId) await this.loadThread()
  },
  watch: {
    $route: async function (newVal, oldVal) {
      if (newVal.query.threadId === oldVal.query.threadId) return
      await this.loadThread()
    },
    canSend: async function (newVal, oldVal) {
      if (newVal === true) {
        await this.getMe()
      }
    },
    loggedIn: async function (newVal, oldVal) {
      if (newVal === true) {
        await this.getMe()
      }
    },
    newMessage: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        // this may be overkill,  possibly we just mark it as read because obviously, we're here
        // but, should probably make sure we're on the thread in context so leaving this in.
        const topic = newVal.topic
        const newMessage = newVal.message
        const threadId = topic.split(':').pop()
        this.getMessageThread.forEach(messageThread => {
          if (messageThread.threadId === threadId) {
            this.markAsRead(newMessage)
          }
        })
      }
    },
    message: async function () {
      if (this.message.client) await this.loadActiveUserSubscriptions(this.message.client._id)
    },
    getMessageThread: async function () {
      /* if (this.getMessageThread.length === 0) {
        await this.setupMessageListeners()
      } */
      clearInterval(this.listenerTimeout)
      if (this.canSend === true) {
        this.connectionAttempt = 0
        this.closeNotification()
      }
      this.listenerTimeout = setInterval(function() {
        if (this.canSend === false) {
          this.isConnected(this.canSend)
          this.connectionAttempt++
          if (this.connectionAttempt > 1) {
            this.options['content'] = 'It looks like your browser is compromised and we can\'t connect to messaging. Please close your browser and try again'
          } else {
            this.options['content'] = 'We are having trouble connecting your browser to the messaging, we are attempting a reconnect now. Please stand by'
          }
          this.options['autoClose'] = false
          this.showNotification = true
        } else {
          this.connectionAttempt = 0
          this.closeNotification()
        }
        // this.setupMessageListeners(true)
        this.listenForMessages(this.$route.query.threadId)
      }.bind(this), 30000)
      if (this.numMessages === 0) {
        this.numMessages = this.getMessageThread.length
      }
      if (this.getMessageThread.length > this.numMessages) {
        this.numMessages = this.getMessageThread.length
        let msgs = this.$el.querySelector('.spnod-messages-container')
        if (msgs.scrollTop > (msgs.scrollHeight - msgs.clientHeight - 50)) {
          setTimeout(function() {
            msgs.scrollTop = msgs.scrollHeight
          }, 50)
        } else {
          if (this.getMessageThread[this.getMessageThread.length - 1].sender._id !== this.getMyInfo._id) {
            this.showNotification = true
          }
        }
      }
    }
  },
  components: { CheckboxModal, Notification, MessageBody, TextArea }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/MessageThread.vue?7fef8a63